import { render, staticRenderFns } from "./AdminDesktop.vue?vue&type=template&id=51db59ac&"
import script from "./AdminDesktop.vue?vue&type=script&lang=ts&"
export * from "./AdminDesktop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports